import React, { Fragment } from 'react';
import { classNames } from '../../Services/helpers';

const Grid = ({items, className, gapY = 'gap-y-2'}) => {
    return <div className={classNames(
        'relative grid grid-cols-[auto,1fr] gap-x-4',
        className,
        gapY,
    )}>
        {items.map((item, i) => {
            if (item.length >= 3 && item[2] === false) {
                return null;
            }
            return <Fragment key={i}>
                <div className="grow-0 shrink-0">
                    {item[0]}
                </div>
                <div className="grow shrink-0">
                    {item[1]}
                </div>
            </Fragment>
        })}
    </div>
}

export default Grid;
